import React from "react";
import { Link } from "react-router";
import footerBg from "../assets/img/bg/footer_bg.jpg";
const Footer = () => {
  return (
    <>
      <footer
        className="footer xb-footer-bg bg_img ukiyo"
        data-u-speed="1.5"
        data-background={footerBg}
        style={{ backgroundImage: `url(${footerBg})` }}
      >
        <div className="xb-footer-wrap pt-120 pb-80">
          <div className="container">
            <div className="xb-footer-inner">
              <div className="xb-footer ul_li pb-75">
                <div className="row align-items-center mt-none-30">
                  <div className="col-lg-6 col-md-6 mt-30 mb-30">
                    <Link
                      className="circle-btn xb-item--left pos-rel"
                      to="contact"
                    >
                      <div className="button__bg"></div>
                      <div className="xb-item--icon">
                        <img src="assets/img/icon/arrow-up-2.svg" alt="" />
                      </div>
                      <span className="xb-item--head">Ping us</span>
                    </Link>
                  </div>

                  <div className="col-lg-3 col-md-12 ">
                    <div className="row">
                      <div className="col-lg-12 col-md-6">
                        <div className="footer-widget">
                          <h4 className="widget-title">SOCIAL MEDIA</h4>
                          <div className="xb-item--content">
                            <a
                              href="https://www.instagram.com/omsoftwares.in/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Instagram..
                            </a>
                            <br />

                            <a
                              href="https://www.facebook.com/omsoftwares1"
                              target="_blank"
                              rel="noreferrer"
                            >
                              Facebook..
                            </a>
                            <br />
                            <a
                              href="https://www.linkedin.com/company/omsoftwares1/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              LinkedIn..
                            </a>
                            <br />
                            <a
                              href="https://github.com/omsoftwares1/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              GitHub..
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-6 mt-10">
                        <div className="footer-widget">
                          <h4 className="widget-title">USEFULL LINKS</h4>
                          <ul className="footer-links">
                            <li>
                              <Link to="/about">About Us</Link>
                            </li>
                            <li>
                              <Link   target="_blank"
                              rel="noopener noreferrer"
                             to="http://careers.omsoftwares.in/">Careers</Link>
                            </li>
                            <li>
                              <Link to="/services">Other Services</Link>
                            </li>
                            <li>
                              <Link to="/faqs">FAQs</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-12 ">
                    <div className="row">
                      <div className="col-lg-12 col-md-6">
                        <div className="footer-widget">
                          <h4 className="widget-title">CONTACT INFO</h4>
                          <div className="xb-item--content">
                            <a
                              className="pcemail footlinkss"
                              style={{ textTransform: "none" }}
                              href="mailto:omsoftwareandtechnologies@gmail.com"
                            >
                              omsoftwareandtechnologies@gmail.com
                              <br />
                            </a>
                            <a className="footlinkss" href="tel:+916239862469">
                              +91 62398-62469
                            </a>
                            <br />
                            <a
                              className="mobemail footlinkss"
                              style={{ textTransform: "none" }}
                              href="mailto:omsoftwareandtechnologies@gmail.com"
                            >
                              E-Mail
                            </a>
                            <a
                              className="footlinkss"
                              style={{ textTransform: "none" }}
                              href="mailto:sales@omsoftwares.in"
                            >
                              sales@omsoftwares.in
                            </a>
                            <br />
                          <a
                              className="footlinkss"
                              style={{ textTransform: "none" }}
                              href="https://wa.me/916239862469"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Whatsapp Us
                            </a>
                            <br />    
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-6 mt-10">
                        <div className="footer-widget">
                          <h4 className="widget-title">SERVICES</h4>
                          <ul className="footer-links">
                            <li>
                              <Link to="/social-media-management">
                                Social Media Management
                              </Link>
                            </li>
                            <li>
                              <Link to="/web-development">Web Development</Link>
                            </li>
                            <li>
                              <Link to="/visual-branding">Visual Branding</Link>
                            </li>
                            <li>
                              <Link to="/digital-marketing">
                                Digital Marketing
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer-bottom ul_li_between">
                <div className="copyright">
                  <p>
                    Copyright © 2020-2026 <Link to="/">Om Softwares</Link>. All
                    rights reserved.
                  </p>
                </div>
                <ul className="footer-nav ul_li_right">
                  <li>
                    <Link to="/terms">Terms and Conditions</Link>
                  </li>
                  <li>
                    <a href="/terms">Privacy Policy</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
